export const contactSearchJson = {
    qualifies: '',
    teamid: '',
    userid: '',
    educationalstatus: '',
    PageSize: 25,
    PageNo: 1,
    searchtxt: '',
    datefrom: '',
    dateto: '',
    percentagefrom: '',
    percentageto: '',
    intakeyear: '',
    preferredintake: '',
    interestedcountry: '',
    englishtest: '',
    month: '',
    yearofcompletion: '',
    interestedlevelofstudy: '',
    platform: '',
    campaignid: '',
    adsetid: '',
    adid: '',
    profile: '',
    Lead_Source: '',
    Priority: '',
    userid2: '',
    contactrating: '',
    enquiryfor: '',
    interested_country2: '',
    FirstActivitya: '',
    FirstActivityb: '',
    LastActivitya: '',
    LastActivityb: '',
    interestedfieldofstudy: '',
    oshc_type: '',
    previous_visa_refusal: '',
    financial_source: '',
    meeting_interface: '',
    meeting_datea: '',
    meeting_dateb: '',
    branchid: '',
    eventId: '',
    subscribed_leads:''
}